import React from 'react';
import nineteen from '../../../assets/Partners_logo/19.png';
import beiBao from '../../../assets/Partners_logo/bei_bao.png';
import henHeXin from '../../../assets/Partners_logo/heng_he_xin.png';
import heXin from '../../../assets/Partners_logo/he_xin.png';
import shangQiu from '../../../assets/Partners_logo/shang_qiu.png';
import xiaTiaTi from '../../../assets/Partners_logo/xiao_tian_ti.png';
import xinChengJan from '../../../assets/Partners_logo/xin_cheng_jian_se.png';
import xingLv from '../../../assets/Partners_logo/xing_lv.png';
import xuGong from '../../../assets/Partners_logo/xu_gong.png';
import yiHang from '../../../assets/Partners_logo/yi_hang.png';
import ZhoJia from '../../../assets/Partners_logo/zhong_jiao.png';
import heng_da from '../../../assets/Partners_logo/heng_da_1.jpg';
import xin_cheng from '../../../assets/Partners_logo/xin_cheng_2.png';
import zhe_yang from '../../../assets/Partners_logo/zhe_yang_3.png';
import jin_zhong from '../../../assets/Partners_logo/jin_zhong_4.png';
import qu_jiang from '../../../assets/Partners_logo/qu_jiang_5.png';
import lu_neng from '../../../assets/Partners_logo/lu_neng_6.png';
import wei_fang from '../../../assets/Partners_logo/wei_fang_7.png';
import jin_jiang from '../../../assets/Partners_logo/jin_jiang_8.jpg';
import yi_hua from '../../../assets/Partners_logo/yi_hua_9.png';

import xiaTiaTi_a from '../../../assets/Partners_logo/20230902-015404.jpg';
// import xinChengJan_b from "../../../assets/Partners_logo/20230906-102307.jpg"
import xingLv_c from '../../../assets/Partners_logo/20230902-015438.jpg';
import xuGong_d from '../../../assets/Partners_logo/20230902-015443.jpg';
import yiHang_g from '../../../assets/Partners_logo/20230902-015447.jpg';
// import ZhoJia_a from "../../../assets/Partners_logo/20230902-015450.jpg"
import xin_cheng_g from '../../../assets/Partners_logo/20230902-015457.jpg';
import zhe_yang_g from '../../../assets/Partners_logo/20230902-015459.jpg';
// import jin_zhong_g from "../../../assets/Partners_logo/20230902-015503.jpg"
import qu_jiang_g from '../../../assets/Partners_logo/20230902-015509.jpg';
// import lu_neng_g from "../../../assets/Partners_logo/20230902-015513.jpg"
import './LogoWrapView.css';

const LogoWrapView = () => {
  // ZhoJia_a ,jin_zhong_g ,xinChengJan_b  lu_neng_g,xinChengJan_b
  const logdData = [
    qu_jiang_g,
    xinChengJan,
    shangQiu,
    xuGong,
    yiHang,
    xiaTiaTi_a,
    xingLv_c,
    xuGong_d,
    xingLv,
    yiHang_g,
    yi_hua,
    xin_cheng_g,
    zhe_yang_g,
    qu_jiang_g,
    xinChengJan,
    shangQiu,
    xuGong,
    yiHang,
  ];
  const logoLIst = [
    jin_zhong,
    qu_jiang,
    lu_neng,
    wei_fang,
    jin_jiang,
    nineteen,
    beiBao,
    henHeXin,
    xiaTiaTi,
    ZhoJia,
    heXin,
    heng_da,
    xin_cheng,
    zhe_yang,
    jin_zhong,
    qu_jiang,
    lu_neng,
    wei_fang,
    jin_jiang,
  ];
  return (
    <div className="logo_wrap">
      <div className="logo_wrap-left"></div>
      <div className="logo_wrap_right"></div>
      <div className="line_odd-right">
        {logoLIst.map((item, i) => {
          return (
            <div key={i} className="line_odd-right-item">
              <img src={item} alt="" className="logo_img" />
            </div>
          );
        })}
      </div>
      <div className="line_odd-left">
        {logdData.map((item, i) => {
          return (
            <div key={i} className="line_odd-left-item">
              <img src={item} alt="" className="logo_img" />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default LogoWrapView;
